module.exports = {

    getTimeStamp() {
        let date = new Date();

        let year = date.getFullYear();
        var month = date.getMonth() + 1;
        var day = date.getDate();
        var hour = date.getHours();
        var minutes = date.getMinutes();
        var seconds = date.getSeconds();

        if (month < 10) {
            month = "0" + month
        }

        if (day < 10) {
            day = "0" + day
        }

        if (hour < 10) {
            hour = "0" + hour
        }

        if (minutes < 10) {
            minutes = "0" + minutes
        }

        if (seconds < 10) {
            seconds = "0" + seconds
        }

        return year + "-" + month + "-" + day + " " + hour + ":" + minutes + ":" + seconds;
    },

    pxToVw(px) {
        return `${px / 375 * 100}vw`
    },
};